import type { ClotureContact, ContactDetail, EntreeEvaluation, MajContact } from '@rh/shared';
import { ErreurReseau, MESSAGE_REPONSE_ILLISIBLE, appel, type OptionsAppel } from '../api';

/**
 * Les quatre requêtes de la file, sous le compte qui a fait la saisie
 * (`x-rh-utilisateur`) et avec un délai : une requête figée ne bloque jamais
 * la file. Une réponse 2xx qui n'est pas le contact demandé vient d'un
 * intermédiaire (portail Wi-Fi) : c'est une panne, pas un succès.
 */

export interface TransportContacts {
  modifier(contactId: string, corps: MajContact, pour: string): Promise<ContactDetail>;
  cloturer(contactId: string, corps: ClotureContact, pour: string): Promise<ContactDetail>;
  evaluer(contactId: string, corps: EntreeEvaluation, pour: string): Promise<ContactDetail>;
  lire(contactId: string, pour: string): Promise<ContactDetail>;
}

export const DELAI_TRANSPORT_MS = 20_000;

type Appel = <T>(chemin: string, options?: OptionsAppel) => Promise<T>;

/** `appeler` n'est passé que par les tests. */
export function transportApi(appeler: Appel = appel): TransportContacts {
  async function demander(contactId: string, suffixe: string, options: OptionsAppel, pour: string) {
    const reponse = await appeler<unknown>(`/contacts/${encodeURIComponent(contactId)}${suffixe}`, {
      ...options,
      pourUtilisateur: pour,
      delaiMs: DELAI_TRANSPORT_MS,
    });
    if (typeof reponse !== 'object' || reponse === null || (reponse as { id?: unknown }).id !== contactId) {
      throw new ErreurReseau(MESSAGE_REPONSE_ILLISIBLE);
    }
    return reponse as ContactDetail;
  }

  return {
    modifier: (contactId, corps, pour) =>
      demander(contactId, '', { method: 'PUT', body: JSON.stringify(corps) }, pour),
    cloturer: (contactId, corps, pour) =>
      demander(contactId, '/cloturer', { method: 'POST', body: JSON.stringify(corps) }, pour),
    evaluer: (contactId, corps, pour) =>
      demander(contactId, '/evaluation', { method: 'POST', body: JSON.stringify(corps) }, pour),
    lire: (contactId, pour) => demander(contactId, '', {}, pour),
  };
}
